import React, { useState, useEffect } from "react";
import { getContactSupport, updateContactSupportStatus } from "../Services/contactSupportService"
import ConfirmationModal from "../Components/ConfirmationModal";
import { toast } from 'react-toastify';
import { contactSupportOptions, customStyles, RoutesPaths } from "../Router/constant";
import Select from 'react-select';
import Skeleton from "../Components/SkeletonLoader";
import { NavLink } from "react-router-dom";

export default function Contactsupport() {
    const [loading, setLoading] = useState(true);
    const [offset, setOffset] = useState(1);
    const [limit] = useState(10);
    const [status, setStatus] = useState("");
    const [confirmation, setConfirmation] = useState({
        show: false,
        contactId: null,
    });
    const [contactSupportData, setContactSupportData] = useState([]);
    const [count, setCount] = useState(0);
    const [closedCounts, setClosedCounts] = useState(0);
    const [openCounts, setOpenCounts] = useState(0);

    const handleDeleteClick = (contactId) => {
        setConfirmation({ show: true, contactId });
    };
    const handleConfirmDelete = async () => {
        try {
            if (confirmation.contactId) {
                const response = await updateContactSupportStatus(confirmation.contactId);
                if (response.data?.status === true) {
                    toast.success('Contact Closed Successfully');
                    fetchSupportData();
                    setConfirmation({ show: false, contactId: null });
                } else {
                    console.error("Delete failed:", response.data?.message || "Unknown error");
                }
            }
        } catch (error) {
            console.error("Error deleting contact:", error);
        }
    };


    const handleCancelDelete = () => {
        setConfirmation({ show: false, contactId: null });
    };


    const fetchSupportData = async () => {
        setLoading(true);

        try {
            const contactResp = await getContactSupport({ offset, limit, status });
            const data = contactResp.data?.data?.contacts || [];
            setContactSupportData(data);
            setCount(contactResp?.data?.data?.total || 0);
            setOpenCounts(contactResp?.data?.data?.opened || 0);
            setClosedCounts(contactResp?.data?.data?.closed || 0)

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchSupportData();
    }, [offset, status]);

    return (
        <>
            <div className="container-fluid">
                <div className="row dashboardSection">
                     <div className="col-md-12">
                        <div className="logisticsMenu">
                            <p>
                                <NavLink to={RoutesPaths.DASHBOARD}>
                                    <img src="/assets/img/homeIcon.svg" alt="" />
                                </NavLink>
                            </p>
                                <img src="/assets/img/chevron-right.svg" alt="" />
                            <p>
                                Contact support
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="bookingManagement">
                            <div>
                                {loading ? <Skeleton width={60} /> : <h6 className="m-0">{count}</h6>}
                                {loading ? <Skeleton width={80} /> : <p className="m-0">Total tickets</p>}
                            </div>
                            <img src="/assets/img/totalBooking.png" alt=" " className="img-fluid" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="bookingManagement">
                            <div>
                                {loading ? <Skeleton width={60} /> : <h6 className="m-0">{openCounts}</h6>}
                                {loading ? <Skeleton width={80} /> : <p className="m-0">Open tickets</p>}
                            </div>
                            <img src="/assets/img/unpaid.jpg" alt=" " className="img-fluid" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="bookingManagement">
                            <div>
                                {loading ? <Skeleton width={60} /> : <h6 className="m-0">{closedCounts}</h6>}
                                {loading ? <Skeleton width={80} /> : <p className="m-0">Close tickets</p>}
                            </div>
                            <img src="/assets/img/checkin.png" alt=" " className="img-fluid" />
                        </div>
                    </div>
                   
                    <div className="col-md-12 bookingDetailsMain">
                        <div className="bookingDetailsOuter">
                            <div className="bookingDetailsAlign">
                                <h6 className="bookingDetailsTitle p-0">Contact support details</h6>
                                <div className="bookingDetailsOuterRight">
                                    <div className="customSelectWrapper">

                                        <Select
                                            className="searchInputSelect"

                                            options={contactSupportOptions}
                                            value={contactSupportOptions.find((opt) => opt.value === status)}
                                            onChange={(selected) => setStatus(selected.value)}
                                            styles={customStyles}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="TableOverFlow">
                                <div className="bookingContent bookingDetailsHeader">
                                    <div className="m-0 userNameWidth">Customer name</div>
                                    <div className="m-0 contactEmailWidth">Email</div>
                                    <div className="m-0 userNameWidth">Phone number</div>
                                    <div className="m-0 userNameWidth">Message</div>
                                    <div className="m-0 userNameWidth">Date</div>
                                    <div className="m-0 supportStatusWidth">Status</div>
                                    <div className="m-0 couponActionWidth">Action</div>
                                </div>

                                <div>
                                    {loading ? (
                                        [...Array(5)].map((_, i) => (
                                            <div className="bookingContent bookingContentData" key={i}>
                                                <div className="m-0 userNameWidth"><Skeleton width={100} /></div>
                                                <div className="m-0 contactEmailWidth"><Skeleton width={140} /></div>
                                                <div className="m-0 userNameWidth"><Skeleton width={100} /></div>
                                                <div className="m-0 userNameWidth"><Skeleton width={120} /></div>
                                                <div className="m-0 userNameWidth"><Skeleton width={90} /></div>
                                                <div className="m-0 supportStatusWidth"><Skeleton width={60} /></div>
                                                <div className="m-0 couponActionWidth"><Skeleton width={70} height={24} /></div>
                                            </div>
                                        ))
                                    ) : contactSupportData.length > 0 ? (
                                        contactSupportData.map((contact) => (
                                            <div
                                                className={`bookingContent bookingContentData ${contact.status === "closed" ? "disabled-row" : ""}`}
                                                key={contact._id}
                                            >
                                                <div className="m-0 userNameWidth">{contact.fullName}</div>
                                                <div className="m-0 contactEmailWidth">{contact.email}</div>
                                                <div className="m-0 userNameWidth">{contact.phoneNumber}</div>
                                                <div className="m-0 userNameWidth">{contact.message}</div>
                                                <div className="m-0 userNameWidth">{new Date(contact.createdAt).toLocaleDateString()}</div>
                                                <div className="m-0 supportStatusWidth">{contact.status}</div>
                                                <div className="m-0 bookingActionButtons couponActionWidth position-relative">
                                                    {contact.status === "opened" ? (
                                                        <button onClick={() => handleDeleteClick(contact._id)} className="viewMore">
                                                            Close
                                                        </button>
                                                    ) : (
                                                        <button className="viewMore" disabled>
                                                            Close
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="noOrders">No contact support found</p>

                                    )}

                                </div>


                            </div>

                            {count > 0 && Math.ceil(count / limit) > 1 && (
                                <div className="paginationSection">
                                    <p
                                        onClick={() => offset > 1 && setOffset(offset - 1)}
                                        style={{
                                            opacity: offset > 1 ? 1 : 0.5,
                                            pointerEvents: offset > 1 ? "auto" : "none",
                                            cursor: offset > 1 ? "pointer" : "default"
                                        }}
                                    >
                                        <img src="/assets/img/arrow-left.svg" alt="Previous" />
                                    </p>

                                    {[...Array(Math.ceil(count / limit))].map((_, index) => (
                                        <p
                                            key={index}
                                            onClick={() => setOffset(index + 1)}
                                            style={{
                                                fontWeight: offset === index + 1 ? "bold" : "normal",
                                                cursor: "pointer"
                                            }}
                                        >
                                            {index + 1}
                                        </p>
                                    ))}

                                    <p
                                        onClick={() => offset < Math.ceil(count / limit) && setOffset(offset + 1)}
                                        style={{
                                            opacity: offset < Math.ceil(count / limit) ? 1 : 0.5,
                                            pointerEvents: offset < Math.ceil(count / limit) ? "auto" : "none",
                                            cursor: offset < Math.ceil(count / limit) ? "pointer" : "default"
                                        }}
                                    >
                                        <img src="/assets/img/arrow-right.svg" alt="Next" />
                                    </p>
                                </div>
                            )}

                            <ConfirmationModal
                                show={confirmation.show}
                                title="Confirm close"
                                message="Do you really want to close this ticket?"
                                onConfirm={handleConfirmDelete}
                                onCancel={handleCancelDelete}
                                confirmText="Yes, close"
                                cancelText="Cancel"
                            />

                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}
